import React from 'react';
import { LoadingState, StatCard, DonutChart, BarGraph, fmt } from './ReportHelpers';

export function OverviewTab({ data, loading }) {
  if (loading) return <LoadingState />;
  if (!data) return null;
  const { quotes, jobs, invoices } = data;
  return (
    <div className="space-y-6" data-testid="overview-tab">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <StatCard label="Total Quotes" value={quotes.total_count} sub={fmt(quotes.total_value)} />
        <StatCard label="Total Jobs" value={jobs.total_count} />
        <StatCard label="Total Invoices" value={invoices.total_count} sub={fmt(invoices.total_value)} />
        <StatCard label="Invoice Revenue" value={fmt(invoices.total_value)} color="text-green-600" />
      </div>
      <div className="grid md:grid-cols-3 gap-4">
        <DonutChart data={quotes.by_status} title="Quotes by Status" />
        <DonutChart data={jobs.by_status} title="Jobs by Status" />
        <DonutChart data={invoices.by_status} title="Invoices by Status" />
      </div>
      <div className="grid md:grid-cols-3 gap-4">
        <BarGraph data={quotes.by_status} title="Quote Status Breakdown" />
        <BarGraph data={jobs.by_status} title="Job Status Breakdown" />
        <BarGraph data={invoices.by_status} title="Invoice Status Breakdown" />
      </div>
    </div>
  );
}
